import { useState } from "react";
import { usePost } from "seed/api";
import l from "components/util/l";
import swal from "sweetalert";

const useRevisionSave = ({
  flow,
  revisionId,
  draftRevisionId,
  content,
  contentWithAnnotations,
  globalAdditionalComments,
  selectedProposalIndex,
  isDeveloper,
  onUpdate,
  onPublishedRevision,
}) => {

  const [saveRevisionForm, setSaveRevisionForm] = useState(null);
  const [isDevCreationMode, setIsDevCreationMode] = useState(false);

  const [callSaveRevision, reqSaveRevision] = usePost("/flows/edit_revision_proposal", {
    onCompleted: (data) => {
      if (onUpdate) onUpdate();
      if (data?.id) onPublishedRevision(data);
      setIsDevCreationMode(false);
      swal(l("Comentarios enviados%PA630"), l("Se han enviado tus comentarios correctamente.%PA632"), "success")
        .then(() => window.location.reload());
    },
  });

  const executeSaveRevision = (
    nextRevisionName = "",
    notificationEmails = [],
    notificationMessage = ""
  ) => {

    const dataToSave = content || {};
    const proposal = dataToSave.proposals[selectedProposalIndex];
    const proposals = [...dataToSave.proposals];

    proposals[selectedProposalIndex] = {
      ...proposal,
      content: contentWithAnnotations.proposals[selectedProposalIndex].content,
      additional_comments: globalAdditionalComments || "",
    };

    callSaveRevision({
      flow_id: flow.id,
      proposal_id: proposal.id,
      target: "content",
      data: {
        type: proposal.type || "major",
        reference: proposal.reference || null,
        content: contentWithAnnotations.proposals[selectedProposalIndex].content,
        additional_comments: globalAdditionalComments || "",
      },
      revision_name: nextRevisionName,
      revision_type: isDeveloper ? "PRODUCT" : "CLIENT",
      priority: isDeveloper ? "LOW" : "HIGHEST",
      status: "PUBLISHED",
    });

  };

  const onClickSaveRevision = async ({
    sections = [],
    values = {},
    activeSectionIndex = 0,
  } = {}) => {
    const pendingSections = sections.filter((section) => {
      if (section.sourceIndex == null) return false;
      if (section.stepIndex > activeSectionIndex) return true;
      return !values[`confirmation-${section.sourceIndex}`];
    });

    if (pendingSections.length > 0) {
      await swal({
        title: l("Todavía hay vistas por revisar%PA638"),
        text: l("Revisa y aprueba todas las vistas antes de enviar comentarios.%PA639"),
        icon: "warning",
        button: l("Entendido%PA640"),
      });
      return;
    }

    const confirmed = await swal({
      title: l("¿Enviar comentarios?%PA634"),
      text: l("Si quieres seguir comentando, guarda cambios. Al enviar, tus comentarios se publicarán para el equipo.%PA635"),
      icon: "warning",
      buttons: {
        cancel: l("Cancelar%GA021"),
        confirm: { text: l("Enviar comentarios%PA610"), value: true },
      },
    });

    if (!confirmed) return;

    if (!isDeveloper) {
      executeSaveRevision("[CLIENT] Cambio revisión");
      return;
    }
    setSaveRevisionForm({
      name: "Cambio revisión",
      notification_emails: [],
      notification_message: "",
    });
  }

  const onCloseSaveRevisionForm = () =>
    setSaveRevisionForm(null);

  const onSubmitSaveRevisionForm = (values) => {
    executeSaveRevision(
      values.name || "Cambio revisión",
      values.notification_emails || [],
      values.notification_message || ""
    );
    setSaveRevisionForm(null);
  }

  return {
    saveRevisionForm,
    setSaveRevisionForm,
    isDevCreationMode,
    isSaving: reqSaveRevision.loading,
    onClickSaveRevision,
    onCloseSaveRevisionForm,
    onSubmitSaveRevisionForm,
  };

};

export default useRevisionSave;
